import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  return (
    <footer
      style={{
        backgroundColor: "#7a9d8b",
        color: "#ffffff",
        fontFamily: "'TT Fors', sans-serif",
      }}
      className="py-4"
    >
      <div className="container">
        <div className="row">
          {/* Nome da Igreja */}
          <div className="col-md-3 mb-3 text-center text-md-start">
            <h3 style={{ fontFamily: "'RoxboroughCF', serif" }}>
              Igreja Casa de Oração
            </h3>
            <p>Fundada em 26 de Janeiro de 2023</p>
          </div>

          {/* Links Importantes */}
          <div className="col-md-3 mb-3 text-center">
            <h5 style={{ fontFamily: "'RoxboroughCF', serif" }}>Conheça</h5>
            <ul className="list-unstyled">
              <li>
                <a
                  href="#sobre"
                  style={{ color: "#ffffff", textDecoration: "none" }}
                >
                  Quem Somos
                </a>
              </li>
              <li>
                <a
                  href="#agenda"
                  style={{ color: "#ffffff", textDecoration: "none" }}
                >
                  Agenda
                </a>
              </li>
              <li>
                <Link
                  to="/politica-de-privacidade"
                  style={{ color: "#ffffff", textDecoration: "none" }}
                >
                  Política de Privacidade
                </Link>
              </li>
              <li>
                <Link
                  to="/termos-de-servico"
                  style={{ color: "#ffffff", textDecoration: "none" }}
                >
                  Termos de Serviço
                </Link>
              </li>
            </ul>
          </div>

          {/* Contato */}
          <div className="col-md-3 mb-3 text-center text-md-start">
            <h5 style={{ fontFamily: "'RoxboroughCF', serif" }}>Contato</h5>
            <p style={{ marginBottom: "0.5rem" }}>
              <i
                className="bi bi-telephone-fill"
                style={{ marginRight: "5px" }}
              ></i>
              +31 6 1514 2684
            </p>
          </div>

          {/* Redes Sociais */}
          <div className="col-md-3 mb-3 text-center text-md-end">
            <h5 style={{ fontFamily: "'RoxboroughCF', serif" }}>
              Redes Sociais
            </h5>
            <a
              href="https://www.instagram.com/casadeoracaohengelo/"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#ffffff",
                textDecoration: "none",
                marginRight: "10px",
              }}
            >
              <i className="bi bi-instagram" style={{ fontSize: "1.5rem" }}></i>
            </a>
            <a
              href="https://www.youtube.com/@IgrejaEvangelicaHengelo"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                color: "#ffffff",
                textDecoration: "none",
                marginRight: "10px",
              }}
            >
              <i className="bi bi-youtube" style={{ fontSize: "1.5rem" }}></i>
            </a>
          </div>
        </div>

        {/* Aviso de Direitos Autorais */}
        <div className="text-center mt-4" style={{ fontSize: "0.9rem" }}>
          © {new Date().getFullYear()} Igreja Casa de Oração. Todos os direitos
          reservados.
        </div>
      </div>
    </footer>
  );
};

export default Footer;
